// Footer CTAs in the mobile menu drawer: each closes the modal <dialog> first, because nothing can paint above the browser top layer.

(function () {
  "use strict";

  var DRAWER_ID = "menu-drawer";
  var LOG_PREFIX = "[menu-drawer] Klaviyo:";
  // Klaviyo mounts the form asynchronously, so success is checked on a delay.
  var OPEN_TIMEOUT = 800;
  var STORED_FORM_ID_KEY = "menu-drawer:klaviyo-form-id";

  function closeDrawer() {
    var drawer = document.getElementById(DRAWER_ID);

    // closeDialog resolves after the close animation, so the popup opens once it has gone.
    if (!drawer || typeof drawer.closeDialog !== "function") return Promise.resolve();

    try {
      return Promise.resolve(drawer.closeDialog());
    } catch (error) {
      return Promise.resolve();
    }
  }

  function firstMatch(selectors) {
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  // Klaviyo rehashes its class names between builds, so match only on its stable attributes.
  var TEASER_SELECTORS = [
    '[data-testid="animated-teaser"] [role="button"]',
    '[class*="kl-teaser-"] [role="button"]',
  ];

  function clickKlaviyoTeaser() {
    var teaser = firstMatch(TEASER_SELECTORS);
    if (!teaser) return false;
    teaser.click();
    return true;
  }

  // The form id is what makes the trigger work, so it is also recovered from the page when unset.
  function storeFormId(formId) {
    if (!formId) return;
    try {
      sessionStorage.setItem(STORED_FORM_ID_KEY, formId);
    } catch (error) {
      // Private mode or a full quota: fall back to DOM discovery next time.
    }
  }

  // sessionStorage, because Klaviyo deletes the form markup as soon as the visitor closes the popup.
  function storedFormId() {
    try {
      return sessionStorage.getItem(STORED_FORM_ID_KEY);
    } catch (error) {
      return null;
    }
  }

  // Klaviyo names its mount point klaviyo-form-<id>, which is exactly the id openForm expects.
  function formIdFromDom() {
    var el = document.querySelector('[class*="klaviyo-form-"]');
    if (!el) return null;

    var match = /klaviyo-form-([A-Za-z0-9]+)/.exec(el.getAttribute("class") || "");
    return match ? match[1] : null;
  }

  // Timestamp of the last form Klaviyo actually opened, which is how a silent no-op is detected.
  var lastOpenAt = 0;

  // Klaviyo announces every form event itself: detail.formId names the form, detail.type the action.
  document.addEventListener("klaviyoForms", function (event) {
    var detail = event && event.detail;
    if (!detail) return;

    if (detail.formId) storeFormId(String(detail.formId));
    if (detail.type === "open" || detail.type === "embedOpen") lastOpenAt = Date.now();
  });

  // Catch an id that rendered before this script's listener was attached.
  storeFormId(formIdFromDom());

  function klOnsite() {
    window._klOnsite = window._klOnsite || [];
    return window._klOnsite;
  }

  function klaviyoLoaded() {
    return typeof klOnsite().openForm === "function";
  }

  function inThemeEditor() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  // Documented shape is openForm([id, callback]); wrapped false tries the unwrapped shape instead.
  function callOpenForm(formId, wrapped) {
    var kl = klOnsite();

    if (typeof kl.openForm !== "function") return false;

    var onOpen = function () {
      lastOpenAt = Date.now();
    };

    if (wrapped) {
      kl.openForm([formId, onOpen]);
    } else {
      kl.openForm(formId, onOpen);
    }
    return true;
  }

  function attempt(fn) {
    try {
      return fn();
    } catch (error) {
      return false;
    }
  }

  function queueOpenForm(formId) {
    return attempt(function () {
      klOnsite().push(["openForm", formId]);
      return true;
    });
  }

  function reportFailure(formId) {
    if (inThemeEditor()) {
      console.warn(
        LOG_PREFIX,
        "form",
        formId,
        "was triggered, but Klaviyo does not render forms inside the theme editor preview." +
          " Test on the storefront (or a preview link) in a normal browser tab instead."
      );
      return;
    }

    if (!klaviyoLoaded()) {
      console.warn(
        LOG_PREFIX,
        "Klaviyo.js is not on this page, so form",
        formId,
        "cannot open. Check the Klaviyo app embed is enabled under Theme settings >" +
          " App embeds, and that no ad/tracking blocker is blocking static.klaviyo.com."
      );
      return;
    }

    console.warn(
      LOG_PREFIX,
      "openForm ran but form",
      formId,
      "did not open. Check the ID matches the end of the form editor URL, the form is" +
        " published, its type is Popup or Flyout, and its Display Timing is 'Only show on" +
        " custom trigger'. Klaviyo also suppresses a form the visitor already submitted."
    );
  }

  // openForm re-renders the form on every call; a teaser click works only until Klaviyo removes it.
  function openKlaviyoForm(configuredFormId) {
    var formId = configuredFormId || formIdFromDom() || storedFormId();

    if (!formId) {
      if (clickKlaviyoTeaser()) return;
      console.warn(
        LOG_PREFIX,
        "no form ID. Set Header > Mobile menu buttons > Klaviyo form ID in the theme editor."
      );
      return;
    }

    storeFormId(formId);

    var triggeredAt = Date.now();
    var ranDirectly = attempt(function () {
      return callOpenForm(formId, true);
    });

    if (!ranDirectly) queueOpenForm(formId);

    // One line per deliberate click, so a silent failure is visible without a debug flag.
    console.info(
      LOG_PREFIX,
      "triggered form",
      formId,
      ranDirectly ? "via openForm()" : "via the _klOnsite queue"
    );

    // openForm is fire-and-forget, so success is read from Klaviyo's own open event.
    window.setTimeout(function () {
      if (lastOpenAt > triggeredAt) return;

      // Other call shapes, in case this Klaviyo build disagrees with the documented one.
      attempt(function () {
        return callOpenForm(formId, false);
      });
      queueOpenForm(formId);

      window.setTimeout(function () {
        if (lastOpenAt > triggeredAt) return;
        if (clickKlaviyoTeaser()) return;
        reportFailure(formId);
      }, OPEN_TIMEOUT);
    }, OPEN_TIMEOUT);
  }

  document.addEventListener("click", function (event) {
    var trigger = event.target.closest("[data-menu-drawer-action]");
    if (!trigger) return;

    var action = trigger.getAttribute("data-menu-drawer-action");

    if (action === "klaviyo") {
      // No href to fall back on, so this click has nowhere else to go.
      event.preventDefault();
      closeDrawer().then(function () {
        openKlaviyoForm(trigger.getAttribute("data-klaviyo-form-id"));
      });
      return;
    }

    if (action === "aiden") {
      // Aiden binds its own handler to [data-advisor-id], so only the drawer is closed here.
      closeDrawer();
    }
  });
})();
